// GraphQL errors as GitHub reports them, and the failure a document whose
// errors cost it its data raises.

export interface GraphQLError {
  message: string;
  type?: string;
  path?: (string | number)[];
  extensions?: Record<string, unknown>;
}

export class GraphQLFailure extends Error {
  constructor(
    public errors: GraphQLError[],
    public data: unknown = null,
  ) {
    super(errors.map((e) => e.message).join('; '));
  }
}

/** True when a GraphQL error is GitHub's SAML SSO enforcement. */
export function isSamlError(e: GraphQLError): boolean {
  return !!e.extensions?.saml_failure || /SAML/i.test(e.message);
}
